// TipCard configuration and state management types

export type TipCardPlacementMode = 'first-in-section' | 'listed-flow';
export type TipCardSection = 'destaque' | 'para_voce' | 'outros';
export type TipCardType = 'standard' | 'banner';

export interface TipCardConfig {
  id: string;
  type: TipCardType;
  enabled: boolean;
  placementMode: TipCardPlacementMode;
  
  // For "first-in-section" mode
  section?: TipCardSection;
  
  // For "listed-flow" mode
  listOrder?: number; // 1, 2, 3, etc.
  
  // Content
  title?: string;
  text: string;
  ctaLabel: string;
  ctaLink?: string; // Optional link for banner cards
  
  // Standard tip styling
  icon?: string;
  backgroundColorToken?: string;
  iconBgColorToken?: string;
  iconColorToken?: string;
  
  // Banner tip styling
  bannerImageUrl?: string;
  bannerOverlayOpacity?: number; // 0.4 - 0.6
  
  // Behavior
  isDismissible: boolean;
}

export interface TipCardState {
  [tipId: string]: {
    dismissed: boolean;
  };
}

// Default TipCard configurations
export const defaultTipCardConfigs: TipCardConfig[] = [
  {
    id: 'speed',
    type: 'standard',
    enabled: true,
    placementMode: 'first-in-section',
    section: 'destaque',
    text: 'Clientes pagaram para aparecer aqui, indicando alto interesse em contratar um profissional.',
    ctaLabel: 'Entendi',
    icon: 'lightbulb',
    backgroundColorToken: '#7c3aed',
    iconBgColorToken: '#6d28d9',
    iconColorToken: '#ffffff',
    isDismissible: true,
  },
  {
    id: 'quality',
    type: 'standard',
    enabled: true,
    placementMode: 'listed-flow',
    listOrder: 1,
    text: 'Avaliando os pedidos, você melhora a recomendação para você.',
    ctaLabel: 'Entendi',
    icon: 'lightbulb',
    backgroundColorToken: '#059669',
    iconBgColorToken: '#047857',
    iconColorToken: '#ffffff',
    isDismissible: true,
  },
  {
    id: 'first',
    type: 'standard',
    enabled: true,
    placementMode: 'listed-flow',
    listOrder: 2,
    text: 'Liberar pedidos que ninguém liberou ainda aumentam suas chances de fechar negócio!',
    ctaLabel: 'Entendi',
    icon: 'lightbulb',
    backgroundColorToken: '#374151',
    iconBgColorToken: '#1f2937',
    iconColorToken: '#ffffff',
    isDismissible: true,
  },
  {
    id: 'safety',
    type: 'standard',
    enabled: true,
    placementMode: 'listed-flow',
    listOrder: 3,
    text: 'Sempre se comunique pela plataforma para se proteger.',
    ctaLabel: 'Entendi',
    icon: 'lightbulb',
    backgroundColorToken: '#374151',
    iconBgColorToken: '#1f2937',
    iconColorToken: '#ffffff',
    isDismissible: true,
  },
  {
    id: 'rating',
    type: 'standard',
    enabled: true,
    placementMode: 'listed-flow',
    listOrder: 4,
    text: 'Clientes veem sua avaliação e comentários. Mantenha seu perfil atualizado!',
    ctaLabel: 'Entendi',
    icon: 'lightbulb',
    backgroundColorToken: '#374151',
    iconBgColorToken: '#1f2937',
    iconColorToken: '#ffffff',
    isDismissible: true,
  },
];